/**
 * @file LanguageToggle.tsx
 * @description Tiny he/en toggle. Updates `document.documentElement.dir`
 *   and `lang` whenever the language changes so the whole tree reflows.
 * @module Components
 * @security Reads i18n state only; no user input involved.
 */

import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

export function LanguageToggle(): JSX.Element {
  const { i18n, t } = useTranslation();
  const onClick = (): void => {
    const next = i18n.language === 'he' ? 'en' : 'he';
    void i18n.changeLanguage(next);
    document.documentElement.dir = next === 'he' ? 'rtl' : 'ltr';
    document.documentElement.lang = next;
  };
  return (
    <button
      type="button"
      onClick={onClick}
      // Pill toggle that inherits its foreground, so it reads correctly
      // on both the dark app chrome and light public pages.
      className="text-xs px-2.5 py-1 rounded-full border border-current opacity-70 hover:opacity-100 transition-opacity focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
    >
      {t('common.toggle_language')}
    </button>
  );
}
